/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { createEntity, getEntity, reset, updateEntity } from './gynic-history.reducer';

export const GynicHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const gynicHistoryEntity = useAppSelector(state => state.gynicHistory.entity);
  const loading = useAppSelector(state => state.gynicHistory.loading);
  const updating = useAppSelector(state => state.gynicHistory.updating);
  const updateSuccess = useAppSelector(state => state.gynicHistory.updateSuccess);

  const handleClose = () => {
    navigate(`/gynic-history${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cycleStart !== undefined && typeof values.cycleStart !== 'number') {
      values.cycleStart = Number(values.cycleStart);
    }
    if (values.cycleEnd !== undefined && typeof values.cycleEnd !== 'number') {
      values.cycleEnd = Number(values.cycleEnd);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...gynicHistoryEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...gynicHistoryEntity,
          patient: gynicHistoryEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.gynicHistory.home.createOrEditLabel" data-cy="GynicHistoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.gynicHistory.home.createOrEditLabel">Create or edit a GynicHistory</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="gynic-history-id"
                  label={translate('tinyMedicRestApp.gynicHistory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.menarche')}
                id="gynic-history-menarche"
                name="menarche"
                data-cy="menarche"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.cycleStart')}
                id="gynic-history-cycleStart"
                name="cycleStart"
                data-cy="cycleStart"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.cycleEnd')}
                id="gynic-history-cycleEnd"
                name="cycleEnd"
                data-cy="cycleEnd"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.loss')}
                id="gynic-history-loss"
                name="loss"
                data-cy="loss"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.interMenstrualBleed')}
                id="gynic-history-interMenstrualBleed"
                name="interMenstrualBleed"
                data-cy="interMenstrualBleed"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.pain')}
                id="gynic-history-pain"
                name="pain"
                data-cy="pain"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.vaginalDischarge')}
                id="gynic-history-vaginalDischarge"
                name="vaginalDischarge"
                data-cy="vaginalDischarge"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.papSmear')}
                id="gynic-history-papSmear"
                name="papSmear"
                data-cy="papSmear"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.contraception')}
                id="gynic-history-contraception"
                name="contraception"
                data-cy="contraception"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.contraceptionDetails')}
                id="gynic-history-contraceptionDetails"
                name="contraceptionDetails"
                data-cy="contraceptionDetails"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.active')}
                id="gynic-history-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.cursor')}
                id="gynic-history-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.lastupdated')}
                id="gynic-history-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.microSec')}
                id="gynic-history-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynicHistory.timestampentry')}
                id="gynic-history-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                id="gynic-history-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.gynicHistory.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/gynic-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default GynicHistoryUpdate;
